import React from "react"
export function Home(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M17.8 8.94a.662.662 0 00-.063-1.003l-7.15-5.745a.952.952 0 00-1.163.012L2.249 8.243a.658.658 0 00-.035 1l.18.173c.2.19.737.272 1.613.247v7.62c0 .397.35.717.78.717h2.797c.431 0 .781-.32.781-.716V10.99h3.567v6.294c-.006.395.303.716.734.716h2.963c.431 0 .781-.32.781-.717V9.416s.896.021 1.186-.272l.204-.205z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__home"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
